import { Component, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
    faArrowLeft,
    faBars,
    faCog,
    faQuestionCircle,
    faUser,
    IconDefinition,
    faChevronUp,
    faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { isNaN } from "lodash";
import { Globals } from "../../app.globals";
import { NavService } from "../../services/nav.service";
import { ProjectsService } from "../../services/projects/projects.service";
import { FormsService } from "../../services/settings/forms.service";
import { ClientService } from "../../services/shared/client.service";
import { UserService } from "../../services/user.service";
import { ClientSwitcherComponent } from "../client-switcher/client-switcher.component";

@Component({
    standalone: false,
    selector: "main-nav",
    templateUrl: "./mainnav.component.html",
    providers: [FormsService, ProjectsService, ClientService],
})
export class MainNavComponent {
    isSyncing: boolean = false;
    navService: NavService;
    userService: UserService;
    globals: Globals;
    faQuestionCircle: IconDefinition = faQuestionCircle;
    faUser: IconDefinition = faUser;
    faLeftArrow = faArrowLeft;
    faBurgerMenu = faBars;
    faGear = faCog;
    faChevronUp = faChevronUp;
    faChevronDown = faChevronDown;

    @ViewChild("clientSwitcher") clientSwitcher: ClientSwitcherComponent;

    private route: ActivatedRoute;
    private router: Router;

    constructor(
        navService: NavService,
        userService: UserService,
        route: ActivatedRoute,
        router: Router,
        globals: Globals
    ) {
        this.navService = navService;
        this.userService = userService;
        this.route = route;
        this.router = router;
        this.globals = globals;
    }

    getProjectId(): number {
        return +this.route.snapshot.params.projectId || null;
    }

    sync() {
        this.router.navigateByUrl(`/qa/access`);
    }

    getMobileMenuLeft() {
        if ((this.navService.menu.topMostMenuItems || []).length === 0)
            return this.navService.menu.mainMenuItems;
        else return this.navService.menu.topMostMenuItems;
    }

    getMobileMenuRight() {
        if ((this.navService.menu.topMostMenuItems || []).length === 0)
            return [];
        else return this.navService.menu.mainMenuItems;
    }

    showCompanies() {
        this.clientSwitcher.show();
    }

    changeClient() {
        let path = "/";
        var urlParts = this.router.url.split("/");
        if (urlParts.length >= 3) {
            if (isNaN(+urlParts[2]) == true) {
                path = this.router.url;
            } else path = "/home";
        } else if (this.router.url.startsWith("/unauthorized")) {
            path = "/home";
        } else {
            path = this.router.url;
        }

        window.location.href = path;
    }

    getCurrentCompany() {
        return this.userService.user.currentClient;
    }

    stopPropogation(event: MouseEvent) {
        event.stopPropagation();
    }

    toggleSubmenu(index: number) {
        const menuItems = this.getMobileMenuRight();
        menuItems[index].showSubmenu = !menuItems[index].showSubmenu;
    }
}
